import { ChartSettings, ScatterWithLineChartSettings } from 'libs/visual-lib/src/lib/modules/charts-graphs/models';

export class ScatterWithLineProcessor {

  /**
   *
   * @param rawData
   * This static function should be overridden by derived classes
   */
  public static processor = (rawData: (any | any[])): (ChartSettings | ScatterWithLineChartSettings) => {
    return <ChartSettings>{
      agChartOptions: null,
      parentActivity: null
    }
  };
}
